module.exports = __webpack_public_path__ + "img/razzo-head-page-4.29227ebd.png";